unit WebBasis2;

interface

uses System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,  WEBLib.Forms, WEBLib.Dialogs, Data.DB,
     XData.Web.Client, XData.Web.Dataset, XData.Web.JsonDataset, Vcl.Imaging.GIFImg, Vcl.Controls, WEBLib.Storage,
     GlobalWeb, VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer;


type
  TfrmWebBasis2 = class(TForm)
    tabSprachDaten: TXDataWebDataSet;
    tabSprachDatenMA_NR: TIntegerField;
    tabSprachDatenMA_NAME: TStringField;
    tabSprachDatenBEGRIFF_UEB: TStringField;
    WaitMessage: TWaitMessage;
    BitmapCont: TTMSFNCBitmapContainer;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);

  private
    procedure Optionen_Laden;
    procedure Optionen_Speichern;

  public
   iID_Sprache : Integer;
   bUebersetzt : Boolean;
   function  Transl( aNummer : Integer; sBegriff : String ) : String;
   [async] procedure Sprach_Daten_Laden( aBereich : String; aID_Sprache : Integer =0 ); async;
   [async] procedure Form_Uebersetzen; async; Virtual;

  protected procedure LoadDFMValues; override; end;

var frmWebBasis2: TfrmWebBasis2;

implementation

Uses UnitMain;

{$R *.dfm}


//====================================================================================================================//

procedure TfrmWebBasis2.Optionen_Laden;
begin

// bei Bedarf im jeweiligen Form implementieren
//  self.Top  := StrToIntDef( TWebLocalStorage.GetValue(self.Name+'TOP'), self.Top);
//  self.Left := StrToIntDef( TWebLocalStorage.GetValue(self.Name+'LEFT'), self.Left);
//  self.Height := StrToIntDef( TWebLocalStorage.GetValue(self.Name+'HEIGHT'), self.Height);
//  self.Width  := StrToIntDef( TWebLocalStorage.GetValue(self.Name+'WIDTH'),  self.Width);

end;

//====================================================================================================================//

procedure TfrmWebBasis2.Optionen_Speichern;
begin

// bei Bedarf im jeweiligen Form implementieren
//  TWebLocalStorage.SetValue( self.Name+'TOP', IntToStr(self.Top) );
//  TWebLocalStorage.SetValue( self.Name+'LEFT', IntToStr(self.Left) );
//  TWebLocalStorage.SetValue( self.Name+'HEIGHT', IntToStr(self.Height) );
//  TWebLocalStorage.SetValue( self.Name+'WIDTH', IntToStr(self.Width) );

end;


//====================================================================================================================//

procedure TfrmWebBasis2.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Optionen_Speichern;
end;

//====================================================================================================================//

procedure TfrmWebBasis2.WebFormCreate(Sender: TObject);
begin

  WaitMessage.PictureURL := frmMainForm.g_WaitGifURL;
  bUebersetzt := False;

  Optionen_Laden;

end;

//====================================================================================================================//

procedure TfrmWebBasis2.WebFormDestroy(Sender: TObject);
begin

end;

//====================================================================================================================//

function TfrmWebBasis2.Transl( aNummer : Integer; sBegriff : String ) : String;
begin
  //console.Log( 'Transl in Basis');
  Result := sBegriff;
  If not tabSprachDaten.Active then Exit;
  If tabSprachDaten.Locate('NUMMER', aNummer, [] ) then Result := tabSprachDatenBEGRIFF_UEB.AsString;
end;

//====================================================================================================================//

procedure TfrmWebBasis2.Sprach_Daten_Laden( aBereich : String; aID_Sprache : Integer =0 );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp : String;
    aSL : TStringList;
    aStream : TStream;
    i : Integer;
    aArray : TArray<string>;
begin

//  If not self.WaitMessage.Showing then self.WaitMessage.Show;

  console.Log('------------------------- frmWebBasis.Sprach_Daten_Laden ---------------');
  console.Log('Bereich: '+aBereich+'  iID_Sprache: '+IntToStr(aID_Sprache) );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', [aBereich,aID_Sprache] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL := TStringList.Create;
  aSL.Text := await( Crypt( sDaten)) ;

  console.Log(  aSL.Text  );

  tabSprachDaten.Close;
  tabSprachDaten.Open;

  If aSL.Count > 2 then
    For i := 2 to aSL.Count -1 Do
        Begin
         sTmp := aSL[i];
          aArray := sTmp.Split([';']);
          tabSprachDaten.Append;
          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
          //console.Log( 'SprachDaten_Laden: ' + tabSprachDaten.FieldByName('BEGRIFF').AsString +' ' +  tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  );
          tabSprachDaten.Post;
        End;

  aSL.Free;

  console.Log('Anzahl: '+IntToStr(tabSprachDaten.Recordcount) );
  console.Log('------------------------------------------------------------------------')

end;

//====================================================================================================================//

procedure TfrmWebBasis2.Form_Uebersetzen;
begin


end;



//====================================================================================================================//


procedure TfrmWebBasis2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WaitMessage := TWaitMessage.Create(Self);
  BitmapCont := TTMSFNCBitmapContainer.Create(Self);
  tabSprachDaten := TXDataWebDataSet.Create(Self);
  tabSprachDatenMA_NR := TIntegerField.Create(Self);
  tabSprachDatenMA_NAME := TStringField.Create(Self);
  tabSprachDatenBEGRIFF_UEB := TStringField.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  tabSprachDatenMA_NR.BeforeLoadDFMValues;
  tabSprachDatenMA_NAME.BeforeLoadDFMValues;
  tabSprachDatenBEGRIFF_UEB.BeforeLoadDFMValues;
  try
    Name := 'frmWebBasis2';
    Width := 544;
    Height := 344;
    Font.Charset := ANSI_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Verdana';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    WaitMessage.SetParentComponent(Self);
    WaitMessage.Name := 'WaitMessage';
    WaitMessage.Left := 291;
    WaitMessage.Top := 44;
    WaitMessage.Width := 24;
    WaitMessage.Height := 24;
    WaitMessage.Cursor := crHandPoint;
    WaitMessage.Opacity := 0.200000000000000000;
    BitmapCont.SetParentComponent(Self);
    BitmapCont.Name := 'BitmapCont';
    BitmapCont.Left := 199;
    BitmapCont.Top := 42;
    BitmapCont.Width := 26;
    BitmapCont.Height := 26;
    BitmapCont.Visible := True;
    BitmapCont.Items.Clear;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap.png');
      Name := 'CANCEL';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_1.png');
      Name := 'OK';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_2.png');
      Name := 'INS';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_3.png');
      Name := 'UPD';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_4.png');
      Name := 'DEL';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_5.png');
      Name := 'LINKS';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_6.png');
      Name := 'RECHTS';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_7.png');
      Name := 'AKT';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_8.png');
      Name := 'FILTER_EIN';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_9.png');
      Name := 'FILTER_AUS';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_10.png');
      Name := 'INFO';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_11.png');
      Name := 'DOWNLOAD';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_12.png');
      Name := 'FAHRZEUG';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_13.png');
      Name := 'POSITION';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_14.png');
      Name := 'NOK';
      Tag := 0;
    end;
    with BitmapCont.Items.Add do
    begin
      Bitmap.LoadFromFile('WebBasis2.BitmapCont.Items.Bitmap_15.png');
      Name := 'OK_GRUEN';
      Tag := 0;
    end;
    tabSprachDaten.SetParentComponent(Self);
    tabSprachDaten.Name := 'tabSprachDaten';
    tabSprachDaten.Left := 240;
    tabSprachDaten.Top := 120;
    tabSprachDatenMA_NR.SetParentComponent(tabSprachDaten);
    tabSprachDatenMA_NR.Name := 'tabSprachDatenMA_NR';
    tabSprachDatenMA_NR.Alignment := taCenter;
    tabSprachDatenMA_NR.DisplayLabel := 'Nummer';
    tabSprachDatenMA_NR.DisplayWidth := 6;
    tabSprachDatenMA_NR.FieldName := 'NUMMER';
    tabSprachDatenMA_NR.Required := True;
    tabSprachDatenMA_NAME.SetParentComponent(tabSprachDaten);
    tabSprachDatenMA_NAME.Name := 'tabSprachDatenMA_NAME';
    tabSprachDatenMA_NAME.DisplayWidth := 20;
    tabSprachDatenMA_NAME.FieldName := 'BEGRIFF';
    tabSprachDatenMA_NAME.Required := True;
    tabSprachDatenMA_NAME.Size := 300;
    tabSprachDatenBEGRIFF_UEB.SetParentComponent(tabSprachDaten);
    tabSprachDatenBEGRIFF_UEB.Name := 'tabSprachDatenBEGRIFF_UEB';
    tabSprachDatenBEGRIFF_UEB.FieldName := 'BEGRIFF_UEB';
    tabSprachDatenBEGRIFF_UEB.Size := 300;
  finally
    WaitMessage.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    tabSprachDatenMA_NR.AfterLoadDFMValues;
    tabSprachDatenMA_NAME.AfterLoadDFMValues;
    tabSprachDatenBEGRIFF_UEB.AfterLoadDFMValues;
  end;
end;

end.